// export const url = "https://xtratoys.nextechltd.in/api";
export const url = "https://pvs001.nextechltd.in/api";

// export const url = "http://103.241.144.228:8000/api";

// export const url = "http://localhost:8001/api";
export const isAdmin = false;

export const adminUrl = "https://pvscpos.nextechltd.in/api";
